var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_911_47447)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_911_47447",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.187695H34.7342V34.9219H0V0.187695Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_911_47447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6868 29.1328C24.6376 29.3673 24.6029 29.6061 24.6029 29.8565C24.6029 31.8551 26.2238 33.4746 28.221 33.4746C30.2197 33.4746 31.8392 31.8551 31.8392 29.8565C31.8392 29.6061 31.8059 29.3673 31.7567 29.1328H24.6868ZM4.42523 29.1328C4.37602 29.3673 4.34129 29.6061 4.34129 29.8565C4.34129 31.8551 5.96221 33.4746 7.95943 33.4746C9.95809 33.4746 11.5776 31.8551 11.5776 29.8565C11.5776 29.6061 11.5443 29.3673 11.4951 29.1328H4.42523ZM27.4974 7.42397H24.6029V16.1075H34.7337V14.6603C34.7337 10.6702 31.4875 7.42397 27.4974 7.42397ZM24.6029 26.2383H34.7337V19.002H24.6029V26.2383ZM21.7084 26.2383H-0.000488281V5.97672C-0.000488281 3.58295 1.94752 1.63494 4.34129 1.63494H17.3666C19.7618 1.63494 21.7084 3.58295 21.7084 5.97672V26.2383Z",
    fill: "#F8A461"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_911_47447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7342,
    height: 34.7342,
    fill: "white",
    transform: "translate(0 0.189453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupOrder);
export default __webpack_public_path__ + "static/media/pickup-order.5cb4a3d8aad6bdf97a9becc2aed5c5a3.svg";
export { ForwardRef as ReactComponent };